const translations: Record<string, string> = {
    application: 'Application',
    battery: 'Battery',
    battery_other: 'Batteries',
    boundary: 'Boundary',
    boundary_other: 'Boundaries',
    chemical: 'Chemical',
    city: 'City',
    classification: 'Classification',
    client: 'Client',
    contactName: 'Contact Name',
    controllerSerialNumber: 'Cntlr. S/N',
    crop: 'Crop',
    drone: 'Drone',
    drone_other: 'Drones',
    droneSerialNumber: 'Drone S/N',
    email: 'Email',
    epaNumber: 'EPA Number',
    estimatedAcres: 'Est. Acres',
    faaRegistrationNumber: 'FAA REG #',
    farm: 'Farm',
    field: 'Field',
    field_other: 'Fields',
    flightControllerFirmwareVersion: 'Firmware',
    flightHours: 'Flight Hrs',
    formulation: 'Formulation',
    manufacturer: 'Manufacturer',
    mix: 'Mix',
    modeOfAction: 'Mode of Action',
    numberOfFlights: 'Flights',
    phone: 'Phone',
    pilot: 'Pilot',
    pilot_other: 'Pilots',
    ppe: 'PPE',
    ppeReentry: 'PPE Reentry',
    rainfastness: 'Rainfastness',
    rei: 'REI',
    role: 'Role',
    scheduledPilot: 'Scheduled Pilot',
    scheduledPilot_other: 'Scheduled Pilots',
    serialNumber: 'BATT S/N',
    signalWord: 'Signal Word',
    state: 'State',
    status: 'Status',
    targetPest: 'Target Pest',
    totalAcres: 'T. Acres',
    totalAreaApplied: 'Area Applied',
    totalVolumeApplied: 'Volume Applied',
    user: 'User',
    warrantyEndDate: 'Wty. End',
    warrantyRemaining: 'Wty. Rmng',
    warrantyStartDate: 'Wty. Start',
    zip: 'ZIP'
};

export default translations;
